<template>
  <div v-html="src" />
</template>

<script>
  export default {
    name: 'Vector',
    props: { src: String }
  }
</script>



// WEBPACK FOOTER //
// src/components/Vector.vue